import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import FormSwitch from '../../../../../components/FormSwitch';
import Tooltip from '../../../../../components/Tooltip';

import { getFields } from '../../helpers';

const Table = ({ access, items, rootClass, title, subTitle, type, onAction, onToggle }) => {
  const fields = useMemo(() => getFields(type), [type]);

  return (
    <div className={classNames('settings-notifications__block', rootClass)}>
      {title && <div className="settings-notifications__block-title">{title}</div>}
      {subTitle && <div className="settings-notifications__block-subtitle">{subTitle}</div>}
      <div className="settings-notifications__block-body">
        <table>
          <thead>
            <tr>
              {fields?.map((field) => (
                <th key={field.key} className={field.thClass}>
                  {' '}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {items?.map((item) => (
              <tr key={item.id} className="settings-notifications__block-body--row">
                {fields?.map((field) => (
                  <td key={field.key} className={field.tdClass}>
                    {field?.key === 'name' ? (
                      <>
                        <div className={classNames({ disabled: item?.access?.can_toggle && !item.is_enabled })}>{item?.[field?.key]}</div>
                        <div className="settings-notifications__block-body--row-desc">{item.description}</div>
                      </>
                    ) : field?.key === 'email' ? (
                      <>
                        <span>{item?.[field?.key]}</span>
                        {' '}
                        <Tooltip
                          placement="top"
                          tooltipClass="tooltip__top"
                          text={item?.is_confirmed ? 'Confirmed email' : 'Unconfirmed email. Notifications will not be sent.'}
                        >
                          {item?.is_confirmed ? <span className="far fa-check-square" /> : <span className="far fa-times-square" />}
                        </Tooltip>
                      </>
                    ) : (field?.key === 'view-staff' || field?.key === 'view-user') && access?.notifications_view ? (
                      <Button bsSize="xsmall" onClick={() => onAction(field?.key, item)}>
                        View
                      </Button>
                    ) : field?.key === 'edit' && access?.notifications_staff_email_edit ? (
                      <Button bsSize="xsmall" onClick={() => onAction(field?.key, item)}>
                        Edit
                      </Button>
                    ) : field?.key === 'toggle' && item?.access?.can_toggle && access?.notifications_toggle_status ? (
                      <FormSwitch checked={!!item.is_enabled} onChange={(e) => onToggle(e, item)} />
                    ) : (
                      item?.[field?.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

Table.propTypes = {
  access: PropTypes.object,
  items: PropTypes.array,
  rootClass: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  type: PropTypes.string,
  onAction: PropTypes.func,
  onToggle: PropTypes.func,
};

export default Table;
